import { createFeatureSelector, createSelector } from '@ngrx/store';
import { SettingsState } from '../settings.state';

export const SETTINGS_FEATURE_STATE_NAME = 'settings';
const FEATURE_STATE = createFeatureSelector<SettingsState>(SETTINGS_FEATURE_STATE_NAME);

export const getLanguage = createSelector(FEATURE_STATE, (state) => state.language);
export const isReady = createSelector(FEATURE_STATE, (state) => state.ready);
